<script>
export default {
    name: 'forkiss-toast',
    props: {
        type: {
            type: String,
            default: 'normal' // success
        },
        visible: {
            type: Boolean,
            required: true
        },
        message: {
            type: String,
            required: true
        }
    }
};
</script>
<template lang="pug">
transition(name="fade")
    div.forkiss-toast(v-if="visible")
        span.success-icon(v-if="type === 'success'")
        span.forkiss-toast-msg(v-html="message")
</template>

<style lang="less" scoped>
.forkiss-toast {
    position: fixed;
    z-index: 1000;
    left: 50%;
    top: 50%;
    border-radius: .12rem;
    padding: .28rem .4rem;
    max-width: 80%;
    transform: translate(-50%, -50%) scale(1);
    transform-origin: center;
    text-align: center;
    color: #fff;
    background: #231d1a;
    // white-space: nowrap;

    .success-icon {
        display: block;
        width: 1rem;
        height: 1rem;
        margin: 0 auto .2rem;
        background-image: url(../assets/success.svg);
        background-size: contain;
        background-repeat: no-repeat;
    }
}
.fade-enter-active, .fade-leave-active {
    transition: transform .5s;
}
.fade-enter, .fade-leave-active {
    transform: translate(-50%, -50%) scale(0);
}
</style>



// WEBPACK FOOTER //
// src/components/toast.vue